import React, { useEffect, useState } from "react";
import axios from "axios";

const ReturnGoodsRequestList = () => {
  const distID = localStorage.getItem("distributorId");
  const boostID = localStorage.getItem("companyIdBooster");
  const userId = localStorage.getItem("userId");
  const userType = localStorage.getItem("userType");

  const [data, setData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedDuration, setSelectedDuration] = useState("All");
  const [expandedOrderId, setExpandedOrderId] = useState(null);

  useEffect(() => {
    fetchOrders("All", "All");
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const fetchOrders = (status, duration) => {
    const requestData = {
      distributorId: distID,
      userType,
      userId,
      companyId: boostID,
      fromDate: "",
      toDate: "",
      status,
      durationInText: duration,
    };

    axios
      .post(
        "https://dpapi.boosterparis.in/api/ReturnGoods/GetReturnGoodsRequestList",
        requestData,
        {
          headers: {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Origin": "*",
            Authorization: localStorage.getItem("loginToken"),
          },
        },
      )
      .then((response) => {
        if (response.data.isSuccess) {
          setData(response.data.result);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleFilterClick = (newStatus, newDuration) => {
    const updatedStatus = newStatus || selectedStatus;
    const updatedDuration = newDuration || selectedDuration;

    setSelectedStatus(updatedStatus);
    setSelectedDuration(updatedDuration);
    fetchOrders(updatedStatus, updatedDuration);

    if (newDuration) {
      document.getElementById("rightFilterSidebar").classList.remove("show");
    }
  };

  const toggleExpand = (id) => {
    setExpandedOrderId(expandedOrderId === id ? null : id);
  };

  return (
    <section className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card card-success">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h3 className="card-title">My Return Goods Requests</h3>
                <a href="/ReturnGoods">
                  <button className="btn btn-primary">New Request</button>
                </a>
              </div>
              <div className="card-body">
                <div className="row">
                  {data.map((item) => (
                    <div key={item.id} className="col-md-4">
                      <div className="card card-primary">
                        <div className="card-header">
                          <h5 className="card-title mb-0">
                            {item.orderNumber}
                          </h5>
                        </div>
                        <div className="card-body">
                          <p>Status: {item.status || "—"}</p>
                          <p>Number Of Items: {item.numberOfItems}</p>
                          <p>Date: {formatDate(item.placedDate)}</p>

                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => toggleExpand(item.id)}
                          >
                            {expandedOrderId === item.id
                              ? "Hide Details"
                              : "View Details"}
                          </button>

                          {expandedOrderId === item.id && (
                            <div className="mt-3">
                              <h6>Line Items</h6>
                              <table className="table table-sm table-bordered">
                                <thead>
                                  <tr>
                                    <th>Product</th>
                                    <th>Qty</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.orderLineItemDTOList.map((line) => (
                                    <tr key={line.orderCartLineItemId}>
                                      <td>{line.productName}</td>
                                      <td>{line.totalQuantityOrdered}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReturnGoodsRequestList;
